export const IMAGE_MAX_SIZE = 36700160; // 35MB
export const FILE_MAX_ZIZE = 36700160; // 35MB
